<style lang="scss" scoped>
.equ {
  width: 416px;
  height: 295px;
  position: absolute;
  left: 107px;
  top: 135px;

  .headers {
    padding-top: 10px;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;

      p {
        font-weight: 700;
        font-size: 24px;
        letter-spacing: 0.1em;
        margin-left: 10px;
      }
    }

    .shuibeng {
      width: 30px;
      height: 30px;
    }
  }

  .goScene {
    cursor: pointer;
    font-size: 18px;
    margin-right: 20px;
    padding: 9.5px 20px;
    background-color: rgba(131, 200, 255, 0.1);
  }

  .pump {
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;

    .data {
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .number {
        font-size: 48px;
        font-family: "dina";

        span {
          font-family: "dina";
          color: #afafaf;
        }
      }
    }

    .data:nth-child(1) {
      .number {
        color: #2d82ff;
      }
    }

    .data:nth-child(3) {
      .number {
        color: #f1802f;
      }
    }
  }

  .state {
    padding: 0 20px;
    margin-top: 20px;
    height: 30px;
    line-height: 30px;
    display: flex;
    font-size: 14px;
    justify-content: space-between;

    .twoState {
      display: flex;
      align-items: center;
      margin-right: 8px;
      color: #c4c4c4;

      .start:before {
        content: "";
        width: 8px;
        height: 8px;
        position: absolute;
        top: 199px;
        right: 128px;
        border-radius: 50%;
        background: rgba(175, 175, 175, 1);
      }

      .standby:before {
        content: "";
        width: 8px;
        height: 8px;
        position: absolute;
        top: 199px;
        right: 66px;
        border-radius: 50%;
        background: rgba(175, 175, 175, 1);
        // background-color: #2D82FF;
      }

      .start {
        margin-right: 34px;
      }
    }

    .active {
      color: #2d82ff;

      &:before {
        background: #2d82ff !important;
      }
    }
  }

  .progress {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    .level {
      .cont {
        margin-top: 20px;
        margin-bottom: 4px;
        font-size: 14px;
      }
    }

    .yewei {
      font-family: "dina";
      font-size: 32px;
      width: 62px;
      height: 37px;
      line-height: 37px;
      text-align: end;
      margin-top: 20px;

      span {
        font-family: "dina";
        font-size: 16px;
        color: #c4c4c4 !important;
      }
    }
  }

  .state2 {
    display: flex;
    margin-right: 20px;
    padding: 8px;
    font-size: 14px;
    color: #c4c4c4;

    .posit2 {
      margin-left: 34px;
    }

    .posit1:before {
      content: "";
      width: 8px;
      height: 8px;
      position: absolute;
      top: 24px;
      right: 130px;
      border-radius: 50%;
      background: rgba(175, 175, 175, 1);
    }

    .posit2:before {
      content: "";
      width: 8px;
      height: 8px;
      position: absolute;
      top: 24px;
      right: 68px;
      border-radius: 50%;
      background: rgba(175, 175, 175, 1);
    }

    .active {
      color: #2d82ff;

      &:before {
        background: #2d82ff !important;
      }
    }
  }

  .pool {
    width: 416px;
    height: 133px;
    margin-top: 20px;

    .progress {
      margin-top: 10px;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;

      .level {
        .cont {
          margin-top: 23px;
          margin-bottom: 4px;
          font-size: 14px;
        }
      }

      .yewei {
        font-family: "dina";
        font-size: 32px;
        width: 62px;
        height: 37px;
        line-height: 37px;
        text-align: end;
        margin-top: 20px;

        span {
          font-family: "dina";
          font-size: 16px;
          color: #c4c4c4 !important;
        }
      }
    }
  }
}
</style>

<template>
  <!-- <div class="equ common-bg" :class="!isIntoWaterPump ? 'back2' : 'back1'">
    <div class="intoWaterPump" @click="intoWater" v-if="isIntoWaterPump"></div>
  </div> -->
  <div class="equ">
    <custom-plane v-if="isIntoWaterPump">
      <div class="headers">
        <div class="left">
          <img
            class="shuibeng"
            src="@/assets/compImg/fireIcon/pump.png"
            alt=""
          />
          <p>消防水泵</p>
        </div>
        <div class="goScene" @click="intoWater">
          进入场景
        </div>
      </div>
      <div class="pump">
        <div v-for="(item, index) in pumpList" :key="index" class="data">
          <p>{{ item.title }}</p>
          <p class="number">{{ item.num }}</p>
        </div>
      </div>
      <div class="state">
        <div>
          当前水泵状态
        </div>
        <div class="twoState">
          <div class="start" :class="{ active: isstart }">启动</div>
          <div class="standby" :class="{ active: !isstart }">待机</div>
        </div>
      </div>
      <div class="progress">
        <div class="level">
          <div class="cont">液位</div>
          <div style="width:198px;margin-top: 2px;">
            <custom-progress-heightline
              :value="((data.SBDQYE * 1) / data.SBYE) * 1 * 100"
              :splitCount="25"
            ></custom-progress-heightline>
          </div>
        </div>
        <div
          class="yewei"
          :class="data.SBDQYEStatus == '0' ? '' : 'error-color'"
        >
          {{ data.SBDQYE }} <span>m</span>
        </div>
      </div>
    </custom-plane>
    <!-- 顶层水池 -->
    <div class="pool" v-if="isIntoWaterPump">
      <custom-plane>
        <div class="headers">
          <div class="left">
            <img
              class="shuibeng"
              src="@/assets/compImg/fireIcon/pool.png"
              alt=""
            />
            <p>顶层水池</p>
          </div>
        </div>
        <div class="progress">
          <div class="level">
            <div class="cont">液位</div>
            <div style="width:198px;margin-top: 2px;">
              <custom-progress-heightline
                :value="((data.level * 1) / data.levelUpperLimit) * 1 * 100"
                :splitCount="25"
              ></custom-progress-heightline>
            </div>
          </div>
          <div
            class="yewei"
            :class="data.levelStatus == '0' ? '' : 'error-color'"
          >
            {{ data.level }} <span class="spanClass">m</span>
          </div>
        </div>
      </custom-plane>
    </div>
    <!-- 切换 -->
    <custom-plane v-if="!isIntoWaterPump" style="height:265px;">
      <div class="headers">
        <div class="left">
          <img
            class="shuibeng"
            src="@/assets/compImg/fireIcon/pump.png"
            alt=""
          />
          <p>消防水泵</p>
        </div>
        <div class="state2">
          <div class="posit1" :class="{ active: isstart }">启动</div>
          <div class="posit2" :class="{ active: !isstart }">待机</div>
        </div>
      </div>
      <div class="pump">
        <div v-for="(item, index) in pumpList" :key="index" class="data">
          <p>{{ item.title }}</p>
          <p class="number">{{ item.num }}</p>
        </div>
      </div>
      <div class="progress">
        <div class="level">
          <div class="cont">液位</div>
          <div style="width:198px;margin-top: 2px;">
            <custom-progress-heightline
              :value="((data.SBDQYE * 1) / data.SBYE) * 1 * 100"
              :splitCount="25"
            ></custom-progress-heightline>
          </div>
        </div>
        <!-- 水泵当前液位 -->
        <div class="yewei">{{ data.SBDQYE }} <span>m</span></div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
export default {
  props: {
    pumpList: Array,
    data: Object,
  },
  computed: {
    isIntoWaterPump() {
      if (Number(this.$route.params.id)) return false;
      else return true;
    },
    isstart() {
      // 判断启动待机
      return this.pumpList[1].num == 0;
    },
  },
  methods: {
    intoWater() {
      // 进入场景隐藏弹框
      this.$emit("closeDialog", false);
      // 进入地下
      this.$store.state.threeEvent.intoFireUnder = true;
      bus.emit("changeScene", "XFBF");
      this.$router.push({ params: { id: 1 } });
    },
  },
  data() {
    return {};
  },
};
</script>
